export type SortLabels = {
  asc: string;
  desc: string;
};

export type ColumnDataType = "date" | "text" | "number" | "default";

export const getSortLabels = (dataType?: ColumnDataType): SortLabels => {
  switch (dataType) {
    case "date":
      // Ascending = chronological (ældst først); descending = nyest først
      return {
        asc: "Ældst",
        desc: "Nyest",
      };
    case "text":
      return {
        asc: "A-Z",
        desc: "Z-A",
      };
    case "number":
      return {
        asc: "Lavest",
        desc: "Højest",
      };
    default:
      return {
        asc: "Stigende",
        desc: "Faldende",
      };
  }
};
